import TutorDashboardShiftSummary from "./components/TutorDashboardShiftSummary.vue";

export const components = {
	TutorDashboardShiftSummary,
};

export { default as store } from "./store/TutorShiftSummary.js";
